export enum ConsultType {
  InitialDoctor = 'Initial - Doctor',
  InitialNurse = 'Initial - Nurse',
  FollowUpDoctor = 'Follow-Up Doctor',
  FollowUpNurse = 'Follow-Up Nurse',
  NotSet = '-',
}

export type GetConsultationTypeReturn = ConsultType;

export const getConsultationType = (row: {
  consult_type?: string;
  doctor_id?: string | number;
}): GetConsultationTypeReturn => {
  if (!row.consult_type) {
    return ConsultType.NotSet;
  }
  if (row.consult_type.includes('Initial')) {
    if (row.doctor_id) {
      return ConsultType.InitialDoctor;
    }
    return ConsultType.InitialNurse;
  }
  if (row.doctor_id) {
    return ConsultType.FollowUpDoctor;
  }
  return ConsultType.FollowUpNurse;
};
